<template>
  <v-layout row>
    <v-flex md3 lg3>
      <GlassesScanned :data="glassesScannedStats"></GlassesScanned>
    </v-flex>
    <v-flex md4 lg4>
      <DoctorOwners :data="doctorOwnersStats" class="ml-2"></DoctorOwners>
    </v-flex>
    <v-flex md5 lg5>
      <Collaborators :data="collaboratorsStats" class="ml-2"></Collaborators>
    </v-flex>
  </v-layout>
</template>

<script>
import GlassesScanned from './GlassesScanned'
import DoctorOwners from './DoctorOwners'
import Collaborators from './Collaborators'
export default {
  name: 'ThirdScreen',
  props: {
    glassesScannedStats: {
      Type: Object
    },
    doctorOwnersStats: {
      Type: Object
    },
    collaboratorsStats: {
      Type: Object
    }
  },
  components: {
    GlassesScanned,
    DoctorOwners,
    Collaborators
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Walldash/ThirdScreen.vue